import React from "react";
import { 
  Container, 
  Typography, 
  Box, 
  Grid, 
  Breadcrumbs, 
  Link as MuiLink
} from "@mui/material";
import { Home, Settings } from "@mui/icons-material";
import { Link } from "react-router-dom";
import UserProfileCard from "../components/UserProfileCard";
import UserPreferencesCard from "../components/UserPreferencesCard";
import SecurityCard from "../components/SecurityCard";

const SettingsPage = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ mb: 2 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <MuiLink
            component={Link}
            to="/"
            color="inherit"
            sx={{ display: 'flex', alignItems: 'center' }}
          >
            <Home sx={{ mr: 0.5 }} fontSize="inherit" />
            Home
          </MuiLink>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Settings sx={{ mr: 0.5 }} fontSize="inherit" />
            Settings
          </Box>
        </Breadcrumbs>
      </Box>

      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Account Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your profile and preferences
        </Typography>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <UserProfileCard />
        </Grid>
        <Grid item xs={12} lg={6}>
          <UserPreferencesCard />
        </Grid>
        <Grid item xs={12}>
          <SecurityCard />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SettingsPage;
